module.exports = __webpack_public_path__ + "static/media/hoc7.c593eadb.jpg";